export * from "./spinner.component"